import { Box, Button, Container, Paper, Stack, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

export default function PaymentCallback() {
  const query = useQuery();
  const navigate = useNavigate();

  const status = (query.get('status') || '').toLowerCase();
  const type = query.get('type') || undefined;
  const message = query.get('message') || undefined;
  const refNo = query.get('refNo') || undefined;
  const returnTo = query.get('returnTo') || undefined;

  const isSuccess = status === 'success';
  const heading = isSuccess ? 'Payment Successful' : 'Payment Failed';
  const color = isSuccess ? 'success.main' : 'error.main';
  const Icon = isSuccess ? CheckCircleOutlineIcon : ErrorOutlineIcon;

  const handleBack = () => {
    if (returnTo) {
      window.location.href = (returnTo);
    } else {
      navigate(-1);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ py: 6 }}>
      <Paper sx={{ p: 4 }}>
        <Stack spacing={2} alignItems="center" textAlign="center">
          <Icon sx={{ fontSize: 64, color }} />
          <Typography variant="h5" fontWeight={700} color={color}>
            {heading}
          </Typography>
          <Box>
            {refNo && (
              <Typography variant="body2" color="text.secondary">Reference No: <strong>{refNo}</strong></Typography>
            )}
            {type && (
              <Typography variant="body2" color="text.secondary">Type: <strong>{type}</strong></Typography>
            )}
            {message && (
              <Stack direction="row" spacing={1} justifyContent="center" mt={1}>
                <InfoOutlinedIcon fontSize="small" color={isSuccess ? 'success' : 'error'} />
                <Typography variant="body2" color="text.secondary">{message}</Typography>
              </Stack>
            )}
          </Box>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} mt={2}>
            <Button variant="contained" onClick={handleBack}>Back to Sample Transaction</Button>
          </Stack>
        </Stack>
      </Paper>
    </Container>
  );
}
